/**
 * `label` is not decoration: a spinner with no accessible name is announced as
 * nothing at all, so a screen reader user gets silence while they wait.
 */
export default function Spinner({ label = 'Loading', size = 28, className = '' }) {
  return (
    <span
      role="status"
      aria-live="polite"
      className={`inline-flex items-center gap-3 text-ink-soft ${className}`}
    >
      <span
        aria-hidden="true"
        style={{ width: size, height: size }}
        className="inline-block animate-spin rounded-full border-[3px] border-sage border-t-forest motion-reduce:animate-none"
      />
      <span className="text-[15px]">{label}</span>
    </span>
  );
}
